import { useQuery } from '@tanstack/react-query';
import UserImportantAlert from '@/app/spraypaint/UserImportantAlert';

type UseUserImportantAlertParams = {
  employeeId?: number | string | null;
  prospectId?: number | string | null;
  enabled?: boolean;
};

export default function useUserImportantAlert({
  employeeId,
  prospectId,
  enabled = true,
}: UseUserImportantAlertParams) {
  const canFetch = enabled && Boolean(employeeId || prospectId);

  const query = useQuery({
    queryKey: ['user-important-alert', { employeeId, prospectId }],
    queryFn: async () => {
      const where = employeeId ? { employeeId } : { prospectId };
      const response = await UserImportantAlert.where(where).per(1).all();
      return response.data[0] ?? null;
    },
    refetchOnWindowFocus: false,
    cacheTime: 0,
    enabled: canFetch,
  });

  return {
    ...query,
    userImportantAlert: query.data ?? null,
  };
}
